export const postList = [
    '/order/batchcreate',
    '/order/batchCreate',
    '/order/create',
    '/order/newcreate',
    '/order/createpay',
    '/log/saveLogEvent',
    '/cart/cartAdd',
    '/cart/getMultiFreight',
    '/comment/post',
    '/comment/v2/doModify',
    '/aftersale/refund',
    '/seckill/jf/ajaxGetSeckillStock',
    '/aftersale/return',
    '/order/refund',
    '/order/newcreate/vtl',
    '/ies/v2/promotion/detailLink',
    '/cart/postFees',
    '/comment/v2/post',
    '/order/changeAddr',
    '/tool/getMicroappStatus',
    '/tool/genShopIMSchema',
    '/aftersale/exchange',
    '/cart/edit',
    '/cart/del',
    '/product/calprice',
    '/product/billInfo',
    '/aweme/v2/shop/cart/collect',
    '/aftersale/exchange'
];
